module.exports = __webpack_public_path__ + "media/02-reszta-z-twoich-zakupow.eeae427e.mp3";